import { Pipe, PipeTransform } from '@angular/core';
import { BankIdStatusEnum } from '@app/enums/bankid-status.enum';

@Pipe({
    name: 'bankIdStatus',
})
export class BankIdStatusPipe implements PipeTransform {
    public transform(value: BankIdStatusEnum = BankIdStatusEnum.waiting): any {
        switch (value) {
            case BankIdStatusEnum.verified:
                return 'success';
            case BankIdStatusEnum.waiting:
                return 'warning';
            case BankIdStatusEnum.checking:
                return 'danger';
            default:
                return '';
        }
    }
}
